var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"trailer-course"},[_c('div',{staticClass:"trailer-wrap"},[_c('small-loader'),_c('video-provider',{attrs:{"is-has-picture-in-picture-mode":false,"videoInfo":_vm.videoInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }